import * as React from "react";
import { Form, Icon, Input, Button, Checkbox } from "antd";
const FormItem = Form.Item;

import { Mutation, MutationFn } from "react-apollo";
import {
  LoginMutation,
  LoginMutationVariables
} from "../../../__generated__/types";
import { LOGIN_QUERY } from "./queries";
import { FormComponentProps } from "antd/lib/form";
import { Link } from "react-router-dom";
import Logo from "../../../components/Logo";

export interface Props extends FormComponentProps {
  children?: React.ReactNode;
  onLogin: (token: string) => void;
}

export interface State {
  loading: boolean;
}

//export const withLogin = graphql<LoginMutation, Props>(LOGIN_QUERY);

class LoginFormMutation extends Mutation<LoginMutation> {}

export class LoginForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { loading: false };
    this.handleLogin = this.handleLogin.bind(this);
  }

  handleLogin(
    event: React.FormEvent<HTMLFormElement>,
    login: MutationFn<LoginMutation, LoginMutationVariables>
  ) {
    event.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (login) {
          this.setState({ loading: true });
          login({
            variables: {
              email: values.userName,
              password: values.password
            }
          })
            .then(response => {
              if (response && response.data) {
                this.props.onLogin(response.data.login.token);
              }
              this.setState({ loading: false });
            })
            .catch(error => {
              console.log("there was an error on login", error);
              this.props.form.setFields({
                userName: {
                  value: values.userName,
                  errors: [new Error()]
                },
                password: {
                  value: "",
                  errors: [new Error()]
                }
              });
              this.setState({ loading: false });
            });
        }
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <LoginFormMutation mutation={LOGIN_QUERY}>
        {(login, { data }) => (
          <Form
            onSubmit={e => this.handleLogin(e, login)}
            className="login-form"
          >
            <Logo />
            <FormItem>
              {getFieldDecorator("userName", {
                rules: [
                  { required: true, message: "Please input your username!" }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Username"
                  readOnly={this.state.loading}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator("password", {
                rules: [
                  { required: true, message: "Please input your Password!" }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder="Password"
                  readOnly={this.state.loading}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator("remember", {
                valuePropName: "checked",
                initialValue: true
              })(
                <Checkbox disabled={this.state.loading}>Remember me</Checkbox>
              )}
              <Link className="login-form-forgot" to="/forgot">
                Forgot password
              </Link>
              <Button
                loading={this.state.loading}
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Log in
              </Button>
            </FormItem>
          </Form>
        )}
      </LoginFormMutation>
    );
  }
}

export default Form.create<Props>()(LoginForm);



// WEBPACK FOOTER //
// ./src/screens/Login/LoginForm/LoginForm.tsx